export default {
  methods: {
    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const units = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(1024));
      return (bytes / Math.pow(1024, i)).toFixed(2) + " " + units[i];
    },
    isValidFileType(file, accept) {
      if (accept === "*") return true;
      const acceptedTypes = accept.split(",").map((t) => t.trim());
      return acceptedTypes.some((type) => {
        if (type.startsWith(".")) {
          return file.name.toLowerCase().endsWith(type.toLowerCase());
        }
        return file.type === type;
      });
    },
    isValidFileSize(file, maxFileSize) {
      if (maxFileSize === null || maxFileSize === undefined) return true;
      return file.size <= maxFileSize;
    },
  },
};
